export enum ErrorEvent {
  /** CoauthorGallery: The information received about the client is invalid */
  InvalidClientInfo = 'InvalidClientInfo',
  /** PermissionsPanel: Invalid response from Permissions API */
  GetPermissionsResponseError = 'GetPermissionsResponseError',
  /** Issues when making getUserPhoto call */
  GetUserPhotoError = 'GetUserPhotoError',
  /** Share: Failures while generating the payload */
  SharePayload = 'SharePayload',
  /** ShareService did not load correctly */
  ShareServiceLoadError = 'ShareServiceLoadError',
  /** Share: Failures on the SPO side while rendering the share dialog */
  ShareSpoError = 'ShareSpoError',
  /** Share: Load timeout for the Share Dialog to load on SPO's side (after payload is created) */
  ShareSpoTimeout = 'ShareSpoTimeout',
  /** Share: Overall load timeout for Share */
  ShareTimeout = 'ShareTimeout',
  /** Share: Unknown failures in the Share Dialog */
  ShareUnknown = 'ShareUnknown'
}
